<template>
  <div class="one-time-pass-with-no-plan-complete-pane">
    <h3 class="one-time-pass-with-no-plan-complete-pane__title">
      {{ $tc('MypagePage.MypageOneTimePass.WithNoPlanCompletePage.title') }}
    </h3>
    <p
      class="one-time-pass-with-no-plan-complete-pane__message"
      v-html="
        $tc('MypagePage.MypageOneTimePass.WithNoPlanCompletePage.message', 0, {
          area: oneTimePassAvailableStoreName,
        })
      "
    />

    <p class="one-time-pass-with-no-plan-complete-pane__period">{{ applicationPeriodText }}</p>

    <action-buttons-section
      scrollTargetSelector=".one-time-pass-with-no-plan-complete-pane__message"
      :visible="true"
    >
      <atom-router-button to="/" :linkText="$tc('common.toRaceList')" colorType="secondary" />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * マイページ: 優待コード: 登録完了ペイン
 */
export default defineComponent({
  name: 'OneTimePassWithNoPlanCompletePane',
  components: { ActionButtonsSection, AtomRouterButton },
  setup() {
    const oneTimePassPageStore = StoreUtil.useStore('OneTimePassPageStore')
    const { oneTimePass, getTargetAvailableArea } = oneTimePassPageStore

    /**
     * 登録したワンタイムパスコードに紐づく店舗名またはエリア名
     */
    const oneTimePassAvailableStoreName = computed(() => {
      const area = getTargetAvailableArea(oneTimePass.value?.availableArea?.areaId ?? '')
      return area?.storeOrAreaName
    })

    /**
     * ワンタイムパス適用期間テキスト
     * 開始日は今日の日付を表示
     */
    const applicationPeriodText = computed(
      () => oneTimePass.value?.couponApplicationPeriodFromTodayText,
    )

    return {
      oneTimePassAvailableStoreName,
      applicationPeriodText,
    }
  },
})
</script>

<style lang="scss" scoped>
.one-time-pass-with-no-plan-complete-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{env(safe-area-inset-bottom)});
  margin: 0 auto;
  padding: 80px 10px;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
  color: $gray75;
  background: $gray1;
  font-feature-settings: 'palt' on;
  letter-spacing: 0.04em;
  font-family: $fontSignup;

  &__title {
    @include fontSetTextMedium(17);

    line-height: 1.41;
    font-weight: 500;
  }

  &__message {
    margin-top: 24px;
    @include fontSetTextMedium(13);

    color: $gray75;
  }

  &__period {
    margin-top: 24px;
    @include fontSetTextMedium(11);

    color: $gray75;
  }
}
</style>
